// Copyright (c) Docugami, Inc. All rights reserved.

import { useWorkPathCache } from "components/work_path/WorkPathCache";
import { MutableRefObject, useEffect, useLayoutEffect, useRef } from "react";

export function usePersistScrollPosition(key: string | undefined, getScrollPosition: () => number | undefined, restoreScrollPosition: (value: number) => void) {
    const cache = useWorkPathCache();

    const getScrollPositionRef = useRef(getScrollPosition);
    const restoreScrollPositionRef = useRef(restoreScrollPosition);

    useEffect(() => {
        getScrollPositionRef.current = getScrollPosition;
    }, [getScrollPosition]);

    useEffect(() => {
        restoreScrollPositionRef.current = restoreScrollPosition;
    }, [restoreScrollPosition]);

    useLayoutEffect(() => {
        if (!key || !cache) {
            return;
        }

        const value = cache.scrollState[key];
        if (value !== undefined) {
            restoreScrollPositionRef.current(value)
        }

        return () => {
            if (!key) {
                return;
            }

            const value = getScrollPositionRef.current();
            if (value !== undefined) {
                cache.scrollState[key] = value;
            }
            else {
                delete cache.scrollState[key];
            }
        }
    }, [key, cache]);
}

export function usePersistDivScrollPosition(key: string | undefined, element: MutableRefObject<HTMLDivElement | null | undefined>) {
    usePersistScrollPosition(key,
        () => element.current?.scrollTop,
        value => element.current?.scrollTo({
            top: value,
            behavior: 'auto'
        }));
}
